import React from 'react';
import './MediaFeatureSection.css';
import SectionBackgroundVideo from './SectionBackgroundVideo';
import { bgImageSet } from './bgImageSet';

const MediaFeatureSection = ({
  id,
  variant = 'light',
  background,
  backgroundMobile,
  title,
  description = [],
  descriptionMobile,
  card,
  cardPlacement = 'left',
  cornerText,
}) => {
  const isVideo = background?.type === 'video';

  // Pass images as CSS variables so the media query can swap them.
  // background-image must NOT be set inline or it will override the CSS rule.
  const sectionStyle =
    !isVideo && background
      ? {
          '--bg-desktop': bgImageSet({
            avif: background.avif,
            webp: background.webp,
            fallback: background.fallback,
          }),
          ...(backgroundMobile && {
            '--bg-mobile': bgImageSet({
              avif: backgroundMobile.avif,
              webp: backgroundMobile.webp,
              fallback: backgroundMobile.fallback,
            }),
          }),
        }
      : undefined;

  const renderCard = () =>
    card && (
      <div
        className='mfs__card'
        style={card.maxWidth ? { '--card-max-width': `${card.maxWidth}px` } : undefined}
      >
        <h3>
          {card.highlight && <span className='mfs__card-highlight'>{card.highlight}</span>}
          {card.highlight ? ' ' : ''}
          {card.heading}
        </h3>
        <p>{card.text}</p>
      </div>
    );

  return (
    <section
      id={id}
      className={`mfs mfs--${variant} ${isVideo ? 'mfs--video' : 'mfs--image'} mfs--card-${cardPlacement}`}
      style={sectionStyle}
    >
      {isVideo && (
        <SectionBackgroundVideo
          webm={background.webm}
          mp4={background.mp4}
          objectPosition={background.position}
          zoom={background.zoom}
          objectPositionMobile={background.positionMobile}
          zoomMobile={background.zoomMobile}
        />
      )}

      <div className='mfs__container'>
        <div className='mfs__left'>
          <h2 className='mfs__title'>{title}</h2>
          <p className={`mfs__desc${descriptionMobile ? ' mfs__desc--desktop' : ''}`}>
            {description.map((line, i) => (
              <React.Fragment key={i}>
                {i > 0 && <br />}
                {line}
              </React.Fragment>
            ))}
          </p>
          {descriptionMobile && (
            <p className='mfs__desc mfs__desc--mobile'>
              {descriptionMobile.map((line, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <br />}
                  {line}
                </React.Fragment>
              ))}
            </p>
          )}
          {cardPlacement === 'left' && renderCard()}
        </div>

        {cardPlacement === 'right' && <div className='mfs__card-right'>{renderCard()}</div>}

        <div className='mfs__corner'>
          <h2 className='mfs__corner-text'>{cornerText}</h2>
        </div>
      </div>
    </section>
  );
};

export default MediaFeatureSection;
